import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { PriceDisplay } from 'pricing-pages-ui-components/price/PriceDisplay';
import { useMemo } from 'react';
import { RECURRING } from 'self-service-api/constants/ChargeTypes';
import { ADD_ON_CARD } from '../../v2/constants/tracking/TrackingSources';
import { useCalculatedPrice } from '../../hooks/useBulkPurchaseOptions';
import { useDisplayedCurrencyCode } from '../../hooks/useCurrencies';
import { useAppSelector } from '../../reducers';
import { productForSkuIdSelector } from '../../selectors/ProductsSelectors';
import SkeletonLoadWrapper from '../common/loading/SkeletonLoadWrapper';
import { AddOnCardPricingFallback } from './AddOnCardFallbacks';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const AddOnCardPricing = ({
  productConfigurations,
  skuId,
  term
}) => {
  const currencyCode = useDisplayedCurrencyCode();
  const product = useAppSelector(state => productForSkuIdSelector(state, {
    skuId
  }));
  const isRecurring = product && product.chargeType === RECURRING;
  const {
    monthlyCalculatedPrice,
    oneTimeFeeCalculatedPrice,
    loading: priceLoading
  } = useCalculatedPrice({
    apiName: product.apiName,
    queryParamTerm: term
  });
  const singleUnitPrice = useMemo(() => {
    const price = isRecurring ? monthlyCalculatedPrice : oneTimeFeeCalculatedPrice;
    if (price) {
      var _productConfiguration;
      const selectedQuantity = ((_productConfiguration = productConfigurations.find(config => config.skuId === skuId)) === null || _productConfiguration === void 0 ? void 0 : _productConfiguration.quantity) || 1;
      return price * selectedQuantity;
    }
  }, [isRecurring, monthlyCalculatedPrice, oneTimeFeeCalculatedPrice, productConfigurations, skuId]);
  if (!singleUnitPrice && !priceLoading) {
    return /*#__PURE__*/_jsx(AddOnCardPricingFallback, {});
  }
  return /*#__PURE__*/_jsx(SkeletonLoadWrapper, {
    isLoading: priceLoading,
    heights: [20],
    widths: ['100%'],
    children: singleUnitPrice && /*#__PURE__*/_jsxs(Text, {
      as: "h6",
      "data-selenium-id": `${ADD_ON_CARD}-${product.apiName}-price`,
      children: [/*#__PURE__*/_jsx(PriceDisplay, {
        price: singleUnitPrice,
        currencyCode: currencyCode
      }), isRecurring ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "planBuilder.priceDisplay.perMonth"
      }) : /*#__PURE__*/_jsx(View, {
        marginBlockStart: '100',
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricingPage.notes.oneTimeFeeParentheses"
        })
      })]
    })
  });
};